import './title2.css'
export default function Title2(){
    return(
        <>
       <div className="h"> <div className="head-2"></div>
        </div>
        <div className="t">
        <h3 className='t-1'>Sauces and Cheeses (Powder)</h3>
        </div>
        </>
    )
}